export default __webpack_public_path__ + "static/tomasz-912f99d35ee73f91fe93aaff53e3dde7.png";